import useDocumentTitle from 'hooks/useDocumentTitle';
import React from 'react'

const Company = () => {
  useDocumentTitle("Company | T360");

  return (
    <div>Company</div>
  )
}

export default Company